import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TableColumn } from 'app/services/common-table.service';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.css']
})
export class TestComponent implements OnInit {
	@ViewChild('geomErrorColumnTempl', { static: false }) geomErrorColumnTempl: TemplateRef<any>;
	tableId = 'testTable';
	rows: any[];
	columns: TableColumn[] = [
		{
			prop: 'column1',
			name: 'column1',
			info: {
				fixedCellClass: []
			}
		}, {
			prop: 'column2',
			name: 'column2',
			info: {
				fixedCellClass: []
			}
		}, {
			prop: 'column3',
			name: 'column3',
			info: {
				fixedCellClass: []
			}
		}
	]
	selectedRows = [];
	tableInfo: {onSelect?} = {};
	geomColName_manual = 'geomManual';
	constructor() { }

	setRows() {
		this.rows = [
			{
				column1: 1,
				column2: 2,
				column3: 3
			}, {
				column1: 4,
				column2: 5,
				column3: 6
			}, {
				column1: 7,
				column2: 8,
				column3: 9
			}, {
				column1: 'a',
				column2: 'b',
				column3: 'c'
			}
		];
	}
	private onSelectRows = () => {
		this.selectedRows[0][this.geomColName_manual] = 'hahaha';
	}

	ngOnInit() {
		this.tableInfo.onSelect = this.onSelectRows;
		this.columns.push({
			prop: this.geomColName_manual,
			name: 'GEOM',
			info: {
				fixedCellClass: []
			}
		})
		this.columns.forEach((col) => {
			if (col.prop === this.geomColName_manual) {
				col.cellTemplate = this.geomErrorColumnTempl;
			}
		});
	}

}
